<mat-chip selectable="false" class="covering-officer-chip" tpClassName="custom-tooltip"
    tp="Covering for {{originalPersonnelName}}" tpMaxWidth="300px" [tpInteractive]="true" tpPlacement="bottom">CO</mat-chip>